var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolygon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.51 4.059a.934.934 0 0 0-.86 0l-2.005 1.15-1.361.734-1.97 1.15a.934.934 0 0 1-.859 0l-1.54-.906a.847.847 0 0 1-.43-.733V3.71c0-.28.144-.559.43-.733l1.54-.872c.25-.14.573-.14.86 0l1.54.907c.25.14.429.419.429.733v1.15l1.36-.767V2.942a.856.856 0 0 0-.43-.733L4.35.57a.934.934 0 0 0-.86 0L.556 2.245a.765.765 0 0 0-.43.698v3.28c0 .279.143.558.43.732l2.9 1.64c.25.14.573.14.86 0l1.969-1.116 1.36-.768 1.97-1.116c.25-.14.573-.14.86 0l1.539.872c.25.14.43.418.43.732v1.745c0 .279-.143.558-.43.733l-1.504.872a.933.933 0 0 1-.86 0L8.11 9.676a.847.847 0 0 1-.43-.733V7.826l-1.36.768v1.151c0 .28.143.559.43.733l2.9 1.64c.25.14.573.14.86 0l2.9-1.64c.25-.14.43-.419.43-.733V6.431a.856.856 0 0 0-.43-.733l-2.9-1.64Z",
    fill: "#8247e5"
  })));
};
export default SvgPolygon;